module.exports = __webpack_public_path__ + "static/media/drtyWaterButton.62e7b411.png";